// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"a073a7fe","832":"78578262","900":"ca28348d"}[chunkId] + ".chunk.js";
};